import * as BlogSectionValidationSchemas from "../components/sections/BlogSection/validation.mjs";
import * as CardSectionValidationSchemas from "../components/sections/CardSection/validation.mjs";
import * as DocumentSectionValidationSchemas from "../components/sections/DocumentSection/validation.mjs";
import * as FaqSectionValidationSchemas from "../components/sections/FaqSection/validation.mjs";
import * as FeaturesSectionValidationSchemas from "../components/sections/FeatureSection/validation.mjs";
import * as HeaderSectionValidationSchemas from "../components/sections/HeaderSection/validation.mjs";
import * as LogoCloudSectionValidationSchemas from "../components/sections/LogoCloudSection/validation.mjs";
import * as TeamSectionValidationSchemas from "../components/sections/TeamSection/validation.mjs";
import * as TestimonialSectionValidationSchemas from "../components/sections/TestimonialSection/validation.mjs";
import * as VideoSectionValidationSchemas from "../components/sections/VideoSection/validation.mjs";
import * as ContentSectionValidationSchemas from "../components/sections/ContentSection/validation.mjs";
import * as CtaSectionValidationSchemas from "../components/sections/CtaSection/validation.mjs";
import * as HeroSectionValidationSchemas from "../components/sections/HeroSection/validation.mjs";
import * as CatalogSectionValidationSchemas from "../components/sections/CatalogSection/validation.mjs";
const sectionsSchemas = {
  ...BlogSectionValidationSchemas,
  ...CardSectionValidationSchemas,
  ...DocumentSectionValidationSchemas,
  ...FaqSectionValidationSchemas,
  ...FeaturesSectionValidationSchemas,
  ...HeaderSectionValidationSchemas,
  ...TeamSectionValidationSchemas,
  ...LogoCloudSectionValidationSchemas,
  ...TestimonialSectionValidationSchemas,
  ...VideoSectionValidationSchemas,
  ...ContentSectionValidationSchemas,
  ...CtaSectionValidationSchemas,
  ...HeroSectionValidationSchemas,
  ...CatalogSectionValidationSchemas
};
export { sectionsSchemas };
